package io.daio.bass

class BassDefaultPlaylist {
    private val queue = mutableListOf<MediaItem>()
    private var currentPosition = 0

    fun current(): MediaItem? = queue.getOrNull(currentPosition)

    fun moveToItem(mediaItem: MediaItem) {
        val newPosition = queue.indexOfFirst { it.url == mediaItem.url }
        moveToPosition(newPosition)
    }

    fun moveToPosition(position: Int) {
        currentPosition =
            position.coerceAtLeast(0)
                .coerceAtMost(queue.size)
    }

    fun add(mediaItem: MediaItem) {
        queue.add(mediaItem)
    }

    fun setItems(
        mediaItems: List<MediaItem>,
        position: Int = 0,
    ) {
        clear()
        queue.addAll(mediaItems)
        moveToPosition(position)
    }

    fun setItem(media: MediaItem) {
        clear()
        queue.add(media)
    }

    fun next(): MediaItem? {
        if (hasNext()) {
            val next = queue.getOrElse(currentPosition + 1) { return null }
            currentPosition++
            return next
        }

        return null
    }

    fun hasNext(): Boolean {
        return currentPosition < queue.size - 1
    }

    fun previous(): MediaItem? {
        if (hasPrevious()) {
            val previous = queue.getOrElse(currentPosition - 1) { return null }
            currentPosition--
            return previous
        }

        return null
    }

    fun hasPrevious(): Boolean {
        return currentPosition > 0
    }

    fun clear() {
        currentPosition = 0
        queue.clear()
    }
}
